import { useMutation as m } from "@tanstack/react-query";
import { customInstance as r } from "../../mutator/custom-instance.es.js";
const s = (t, n, e, o) => r({
  url: `/modify/${t}/reschedule`,
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  data: n,
  signal: o
}, e), c = (t) => {
  const n = ["rescheduleBooking"], {
    mutation: e,
    request: o
  } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : {
    ...t,
    mutation: {
      ...t.mutation,
      mutationKey: n
    }
  } : {
    mutation: {
      mutationKey: n
    },
    request: void 0
  };
  return {
    mutationFn: (u) => {
      const {
        bookingId: i,
        data: a
      } = u ?? {};
      return s(i, a, o);
    },
    ...e
  };
}, g = (t) => {
  const n = c(t);
  return m(n);
};
export {
  c as getRescheduleBookingMutationOptions,
  s as rescheduleBooking,
  g as useRescheduleBooking
};
